module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/meltdown-d60c242db7974cc7010a0ede64e8b2f5.webp";